/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { GuideType, InteractiveComponents } from '../../../core/enums';
import { ScreenTaskControllerTypes } from '../../../core/navigation';
import { resetCategoriesFilterAction } from '../../overlay/channeloptionsoverlay/channeloptionsoverlay.actions';
import { EmptyFilteredGuideChannelOptionsOverlayActions } from '../../overlay/channeloptionsoverlay/channeloptionsoverlay.enum';
import {
    channelOptionsOverlayApplyFilter,
    showGuideOptionsOverlay,
    userHasSelectedCategoryFilter,
} from '../../overlay/channeloptionsoverlay/channeloptionsoverlay.reducers';
import {
    onKeyBackNoNetworkOverlay,
    onKeyOkNoNetworkOverlay,
} from '../../overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import { setOverlayHighlightVerticalPositionAction } from '../../overlay/overlayhighlight/overlayhighlight.actions';
import { GLOBAL_MOUSE_TRAP } from '../../overlay/pcpinoverlay/pcpinoverlay.reducers';
import {
    hideOverlayDialog,
    onKeyDownOverlayDialog,
    onKeyLeftOverlayDialog,
    onKeyRightOverlayDialog,
    onKeyUpOverlayDialog,
    onMouseOutOverlayDialogOperations,
    onMouseOverOverlayDialogOperations,
} from '../../overlaydialog/overlaydialog.reducers';
import { showGuideScreen } from '../../screens/screens.reducers';

export const onKeyBackEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            dispatch(resetCategoriesFilterAction());
            dispatch(showGuideScreen());
            return;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyBackNoNetworkOverlay());
            break;

        default:
            dispatch(hideOverlayDialog());
    }
};

export const onKeyOkEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition, horizontalPosition } = getState().overlayHighlight;
    const { screenTaskController } = getState().screens;

    const categoriesFilterIndex =
        EmptyFilteredGuideChannelOptionsOverlayActions.CATEOGORIES_FILTER_PILL;
    const channelsFilterIndex = EmptyFilteredGuideChannelOptionsOverlayActions.CHANNELS_FILTER_PILL;
    const filterButtonIndex =
        EmptyFilteredGuideChannelOptionsOverlayActions.VIEW_GUIDE_WITH_SELECTED_FILTERS;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS:
            return;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyOkNoNetworkOverlay());
            break;

        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY: {
            const userSelectedCategoryFilterValue = userHasSelectedCategoryFilter(
                categoriesFilterIndex,
                horizontalPosition,
            );

            if (verticalPosition === filterButtonIndex) {
                dispatch(
                    channelOptionsOverlayApplyFilter(categoriesFilterIndex, channelsFilterIndex),
                );

                if (userSelectedCategoryFilterValue) {
                    return;
                }

                dispatch(showGuideScreen());
                return;
            }
            // change user highlight to apply filter button
            dispatch(setOverlayHighlightVerticalPositionAction(filterButtonIndex));

            break;
        }
        default:
    }
};

export const onLongKeyOkEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        dispatch(showGuideOptionsOverlay(GuideType.FILTERED_GUIDE));
    }
};

export const onKeyUpEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyUpOverlayDialog());
            break;
        default:
            break;
    }
};

export const onKeyDownEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY:
        case ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY:
            dispatch(onKeyDownOverlayDialog());
            break;
        default:
            break;
    }
};

export const onKeyRightEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }
    dispatch(onKeyRightOverlayDialog());
};

export const onKeyLeftEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }
    dispatch(onKeyLeftOverlayDialog());
};

export const onMouseOverEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }
    dispatch(onMouseOverOverlayDialogOperations());
};

export const onMouseOutEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }
    dispatch(onMouseOutOverlayDialogOperations());
};

export const onMouseClickEmptyFilteredGuide = () => (dispatch: Function, getState: Function) => {
    const {
        interactiveLayer: { activeComponent },
        inputFactory: { value },
        screens: { screenTaskController },
    } = getState();

    if (screenTaskController !== ScreenTaskControllerTypes.CHANNEL_OPTIONS_OVERLAY) {
        return;
    }

    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(hideOverlayDialog());
        return;
    }

    if (activeComponent === InteractiveComponents.WEST) dispatch(onKeyLeftOverlayDialog());
    else if (activeComponent === InteractiveComponents.EAST) dispatch(onKeyRightOverlayDialog());
    else dispatch(onKeyOkEmptyFilteredGuide());
};
